<template>
    <FormSection title="Referral Information" :full-height="false" :application-id="referral.application">
        <template id="Referral_Source" #content>
            <div class="row px-4 py-2">
                <div class="col-12 offset-lg-1 col-lg-10 row g-0">
                    <div
                        class="form-group col-12 col-lg-5 pe-lg-2 d-flex flex-column"
                        v-if="referral.application == hospiceApplicationId"
                    >
                        <label for="line-of-service">
                            Line of Service
                            <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex flex-wrap mt-1" v-if="lineOfServices.length > 0">
                            <div
                                v-for="lineOfService of lineOfServiceOptions"
                                class="form-check custom-radio form-check-inline d-inline"
                            >
                                <input
                                    type="radio"
                                    :id="`line- of-service-${lineOfService.name}`"
                                    class="form-check-input"
                                    name="line-of-service"
                                    :checked="referral.lineOfService === lineOfService.value"
                                    :value="`${lineOfService.value}`"
                                    disabled
                                />
                                <label class="form-check-label" :for="`line-of-service-${lineOfService.name}`">
                                    <span class="me-1">{{ lineOfService.name }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 pe-lg-3" v-else>
                        <div class="form-group">
                            <label for="referral-reason">
                                Referral Reason
                                <span class="text-danger">*</span>
                            </label>
                            <textarea
                                class="form-control"
                                name="referral-reason"
                                v-model="referral.referralReason"
                                placeholder="Enter Reason"
                                maxlength="500"
                                @blur="v$.referral.referralReason.$touch"
                                :class="`${!v$.referral.referralReason.$error ? '' : 'field-invalid'}`"
                            ></textarea>
                        </div>
                        <span v-if="v$.referral.referralReason.$error" class="field-invalid"
                            >Referral reason is required.</span
                        >
                    </div>
                    <div class="form-group col-12 col-lg-4 pe-lg-2">
                        <div class="form-group">
                            <label for="referral-date">
                                Referral Date
                                <span class="text-danger">*</span>
                            </label>
                            <DatePicker :options="datePickerOptions" :getDate="handleDateChange">
                                <div class="input-group date datepickerInput">
                                    <input
                                        name="referralDate"
                                        type="text"
                                        class="form-control"
                                        placeholder="MM/DD/YYYY"
                                        :value="formatDateInput(referral.referralDate)"
                                        @change="(e) => handleDateChange(e.target.value, e.target.name)"
                                        autocomplete="off"
                                        @blur="v$.referral.referralDate.$touch"
                                        :class="`${!v$.referral.referralDate.$error ? '' : 'field-invalid'}`"
                                    />
                                    <div class="input-group-addon input-group-append">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                    <span v-if="v$.referral.referralDate.$error" class="field-invalid">{{
                                        v$.referral.referralDate.$errors[0].$message
                                    }}</span>
                                </div>
                            </DatePicker>
                        </div>
                        <div class="form-group">
                            <label for="referral-service-location"> Patient Current Location </label>
                            <input
                                class="form-control"
                                name="referral-service-location"
                                maxlength="50"
                                type="text"
                                placeholder="Enter Current Location"
                                v-model="referral.patientCurrentLocation"
                            />
                        </div>
                        <div class="form-group">
                            <label for="inquiry-date"> Inquiry Date </label>
                            <DatePicker>
                                <div class="input-group date datepickerInput">
                                    <input
                                        id="inquiry-date"
                                        name="inquiryDate"
                                        type="text"
                                        class="form-control"
                                        placeholder="MM/DD/YYYY"
                                        :value="referral.inquiryDate ? formatDateInput(referral.inquiryDate) : 'Not Available'"
                                        autocomplete="off"
                                        disabled
                                    />
                                    <div class="input-group-addon input-group-append">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                            </DatePicker>
                        </div>
                    </div>
                    <NewReferralInformation :provider-id="providerId" />
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./HosPalReferralInformation.ts"></script>
